import axios from "axios";
import {
  Category,
  ProjectModel,
  ProjectModelFromJson,
} from "../models/projectModel";

// export async function fetchProject(id:string) {
//   const response = await axios.get(
//     `https://esonmez-portfolio-default-rtdb.europe-west1.firebasedatabase.app/projects/${id}.json`
//   );
//   try {
//     if (response.data) {
//       var fetchedData: ProjectModel[] = [];

//       Object.keys(response.data).map((e) =>
//         fetchedData.push(ProjectModelFromJson(e, response.data[e]))
//       );
//       return fetchedData[0];

//     }

//   } catch (error) {
//     console.log(error);
//     throw new Error(`${error}`);
//   }

// }

interface Props {
  filterCategory?: Category[];
  filterByKey?: string;
  admin?: boolean;
}

export async function fetchProjects({
  filterCategory = undefined,
  filterByKey = undefined,
  admin = false
}: Props) {
  const response = await axios.get(
    "https://emresn-info-default-rtdb.europe-west1.firebasedatabase.app/projects.json"
  );

  try {
    if (response.data) {
      var fetchedData: ProjectModel[] = [];

      Object.keys(response.data).map((e) =>
        fetchedData.push(ProjectModelFromJson(e, response.data[e]))
      );

      fetchedData.sort(function (a, b) {
        if (Date.parse(a.latestUpdate) > Date.parse(b.latestUpdate)) {
          return -1;
        } else {
          return 1;
        }
      });

      if (!admin) {
        fetchedData = fetchedData.filter((e) => e.isDeactive !== true);
      }

      if (filterCategory) {
        const filteredData = fetchedData.filter((p) => {
          const filteredKeys = filterCategory.map((f) => f.key);
          if (filteredKeys.includes(p.category.key)) {
            return true;
          } else {
            return false;
          }
        });

        return filteredData;
      } else if (filterByKey) {
        const filteredData = fetchedData.filter((p) => p.key === filterByKey);
        return filteredData;
      } else {
        return fetchedData;
      }
    }
  } catch (error) {
    // console.log(error);
    throw new Error(`${error}`);
  }
}
